// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1EntrySchema } from './v1/entrySchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listEntriesQueryParamsSchema = z.object({
  date: z.optional(z.string().date().describe("Date to retrieve entries for (YYYY-MM-DD). Defaults to current date")),
  entry_ids: z.optional(z.coerce.string().describe("Comma-separated list of entry IDs to filter by")),
  order: z.optional(z.enum(["asc", "desc"]).describe("Sort order by updated_at. Defaults to desc")),
  exclude_tracker_entries: z.optional(z.array(z.coerce.string()).describe("Tracker app names to exclude from results")),
}).optional();

export const listEntriesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Entries list
 */
export const listEntries200Schema = z.array(z.lazy(() => v1EntrySchema));

/**
 * @description Unauthorized
 */
export const listEntries401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listEntriesQueryResponseSchema = z.lazy(() => listEntries200Schema);
